import React from 'react';
import { Box } from '@mui/material';
import YeloLogo from 'app/components/Icons/YeloLogo';
import { header, mainBox, bgImage, footer } from './AuthHeader.sx';
import { Outlet } from 'react-router-dom';
import LanguageSwitcher from 'app/components/LanguageSwitcher';
import CallLogo from 'app/components/Icons/CallLogo';
const AuthHeader = () => {
  return (
    <Box sx={mainBox}>
      <Box sx={bgImage}>
        <Box sx={{ position: 'absolute', left: '0', bottom: '-7px', zIndex: '-1' }}>
          <img src="/images/Business-photo-transparent.png" alt="" width={'600'} />
        </Box>
      </Box>
      <Box sx={header}>
        <YeloLogo />
        {/*<LanguageSwitcher />*/}
      </Box>
      <Outlet />
      <Box sx={footer}>
        <a href={'tel:012981'}>
          <CallLogo />
        </a>
      </Box>
    </Box>
  );
};

export default AuthHeader;
